<template>
	<base-layout :withHeaderStructure="true">
		<template v-slot:header>
			<h1 class="text-3xl mt-5 text-center leading-6 text-gray-900 font-bold tracking-tight">
				Testimonials
			</h1>
			<h2 class='leading-5 mt-3 mb-3 text-center text-gray-700 text-sm'  > 
				Over the years, The Broker Site has built up an impressive reputation, being Europe's leading Computer Trading Exchange.<br/>
				Don't take our word for it, feel free to see what our members say about The Broker Site!
			</h2>
		</template>
		<template v-slot:main>
			<testimonials :testimonials='testimonials'/>
		</template>
	</base-layout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue'
import Testimonials from '@/components/Testimonials.vue';
import { mapState, mapGetters } from 'vuex';
import { useSchemaOrg } from '../composables/useSchema.org.js';

export default {
  name: 'TestimonialsPage',
  components: {
    BaseLayout, 
    Testimonials
  },
  watch: {
	testimonials: {
      handler(newVal) {
        if (newVal) {
        	this.addTestimonialSchema();
        }
      },
      deep: true,
      immediate: false
    },
  },
  computed: {
  	...mapState([ 'testimonials']),
  },
  methods: {
	addTestimonialSchema() {
      const testimonialSchema = {
          "name": "Customer Testimonials - The Broker Site",
          "description": "Read authentic testimonials from members of TheBrokerSite.com. Discover why brokers worldwide trust our platform for secure trading, networking, and business growth.",
          "@type": "ItemList",
          "itemListElement": this.testimonials.map((testimonial, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                  "@type": "Review",
                  "author": {
                      "@type": "Person",
                      "name": testimonial.name 
                  },
                  "reviewBody": testimonial.description, 
                  
              }
          }))
      };
      useSchemaOrg(testimonialSchema);
    }
  }
}
</script>
